/* A&W&A Pianina – luxe theme */
(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s)};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var body=document.body;

  /* ---------- reveal ---------- */
  var rv=$$('.reveal');
  if('IntersectionObserver' in window && rv.length){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.05});
    rv.forEach(function(el){io.observe(el)});
  }else{rv.forEach(function(el){el.classList.add('is-in')})}

  /* ---------- nagłówek ---------- */
  var hdr=$('#Header');
  if(hdr){var onS=function(){hdr.classList.toggle('is-stuck',window.scrollY>40)};onS();window.addEventListener('scroll',onS,{passive:true})}

  /* ---------- szuflady ---------- */
  var bgs=$$('[data-drawer-bg]');
  function closeAll(){
    ['MobileNav','CartDrawer','Filters'].forEach(function(id){var el=document.getElementById(id);if(el){el.classList.remove('is-open');el.setAttribute('aria-hidden','true')}});
    bgs.forEach(function(b){b.classList.remove('is-open')});body.classList.remove('no-scroll');
  }
  function openDrawer(id){
    var el=document.getElementById(id);if(!el)return;
    closeAll();el.classList.add('is-open');el.setAttribute('aria-hidden','false');
    bgs.forEach(function(b){b.classList.add('is-open')});body.classList.add('no-scroll');
    var f=el.querySelector('a,button,input');if(f&&id!=='CartDrawer')try{f.focus({preventScroll:true})}catch(e){}
  }
  document.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-open-menu]')){openDrawer('MobileNav');return}
    if(t.closest('[data-open-filters]')){openDrawer('Filters');return}
    var oc=t.closest('[data-open-cart]');
    if(oc&&document.getElementById('CartDrawer')&&!/\/cart/.test(location.pathname)){e.preventDefault();openCart();return}
    if(t.closest('[data-close-drawers]')||t.hasAttribute('data-drawer-bg')){closeAll();return}
    var st=t.closest('[data-toggle-search]');
    if(st){var sb=$('#SearchBar');var o=!sb.classList.contains('is-open');sb.classList.toggle('is-open',o);st.setAttribute('aria-expanded',o);if(o){var i=$('input[type=search]',sb);i&&setTimeout(function(){i.focus()},120)}return}
    var oi=t.closest('[data-open-inquiry]');
    if(oi){var d=$('[data-inquiry]');if(d){d.open=true;setTimeout(function(){d.scrollIntoView({behavior:'smooth',block:'center'})},30)}e.preventDefault();return}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeAll();var sb=$('#SearchBar');sb&&sb.classList.remove('is-open');closeLb()}});
  $$('[data-auto-submit]').forEach(function(s){s.addEventListener('change',function(){s.form&&s.form.submit()})});

  /* ---------- toast ---------- */
  var toastEl=$('#Toast'),tt;
  function toast(msg){if(!toastEl)return;toastEl.textContent=msg;toastEl.classList.add('is-show');clearTimeout(tt);tt=setTimeout(function(){toastEl.classList.remove('is-show')},2800)}

  /* ---------- koszyk ---------- */
  var drawer=document.getElementById('CartDrawer');
  var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'PLN';
  function money(c){
    var v=c/100;
    try{return new Intl.NumberFormat(document.documentElement.lang||'pl',{style:'currency',currency:cur,minimumFractionDigits:v%1?2:0,maximumFractionDigits:2}).format(v)}catch(e){return v.toFixed(2)+' '+cur}
  }
  function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML}
  function root(p){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/'}
  function renderCart(cart){
    if(!drawer)return;
    var bodyEl=$('[data-cart-body]',drawer),foot=$('[data-cart-foot]',drawer);
    $$('[data-cart-count]').forEach(function(c){c.textContent=cart.item_count;c.hidden=!cart.item_count});
    var lab=$('[data-cart-count-label]',drawer);if(lab)lab.textContent=cart.item_count?'('+cart.item_count+')':'';
    if(!cart.item_count){
      bodyEl.innerHTML='<div class="cart-empty"><svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M8 40h48v14H8zM12 40V22a4 4 0 014-4h32a4 4 0 014 4v18M8 54v5M56 54v5"/></svg><h4>'+esc(drawer.dataset.sEmpty)+'</h4><p>'+esc(drawer.dataset.sEmptyText)+'</p><a class="btn btn--ghost" href="'+esc(drawer.dataset.sAll)+'">'+esc(drawer.dataset.sContinue)+'</a></div>';
      foot.hidden=true;return;
    }
    bodyEl.innerHTML=cart.items.map(function(it){
      var v=it.variant_title&&it.variant_title!=='Default Title'?'<span class="ci__var">'+esc(it.variant_title)+'</span>':'';
      return '<div class="ci" data-key="'+esc(it.key)+'"><a class="ci__img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(it.image.replace(/(\.[a-z]+)(\?|$)/i,'_300x$1$2'))+'" alt="'+esc(it.product_title)+'" loading="lazy">':'')+'</a><div class="ci__info">'
        +(it.vendor?'<span class="ci__brand">'+esc(it.vendor)+'</span>':'')+'<a class="ci__title" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+v
        +'<div class="ci__row"><div class="qty"><button type="button" data-qty="-1" aria-label="−">−</button><span>'+it.quantity+'</span><button type="button" data-qty="1" aria-label="+">+</button></div><span class="ci__price">'+money(it.final_line_price)+'</span></div>'
        +'<button class="ci__rm" type="button" data-remove>'+esc(drawer.dataset.sRemove)+'</button></div></div>';
    }).join('');
    $('[data-cart-total]',drawer).textContent=money(cart.total_price);foot.hidden=false;
  }
  function loadCart(){return fetch(root()+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){renderCart(c);return c})}
  function openCart(){loadCart();openDrawer('CartDrawer')}
  if(drawer){
    drawer.addEventListener('click',function(e){
      var row=e.target.closest('.ci');if(!row)return;
      var key=row.dataset.key,q=parseInt($('.qty span',row).textContent,10);
      var b=e.target.closest('[data-qty]'),rm=e.target.closest('[data-remove]');
      if(!b&&!rm)return;
      var nq=rm?0:q+parseInt(b.dataset.qty,10);
      fetch(root()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,nq)})}).then(function(r){return r.json()}).then(renderCart).catch(function(){toast(drawer.dataset.sError)});
    });
  }
  function addToCart(id){
    return fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json()}).then(function(){if(drawer)openCart();else{loadCart();toast(drawer?'':'✓')}})
      .catch(function(){toast(drawer?drawer.dataset.sError:'Error')});
  }

  /* ---------- produkt: warianty / dodawanie ---------- */
  var form=$('#ProductForm');
  if(form){
    var vid=$('[data-variant-id]',form),priceEl=$('[data-price]'),sbp=$('[data-sbar-price]');
    $$('input[name=variant_pick]',form).forEach(function(r){r.addEventListener('change',function(){
      vid.value=r.value;var h=r.dataset.price+(r.dataset.compare?'<s>'+r.dataset.compare+'</s>':'');
      if(priceEl)priceEl.innerHTML=h;if(sbp)sbp.textContent=r.dataset.price;
    })});
    form.addEventListener('submit',function(e){e.preventDefault();addToCart(parseInt(vid.value,10))});
    var proxy=$('[data-add-proxy]');proxy&&proxy.addEventListener('click',function(){addToCart(parseInt(vid.value,10))});
  }

  /* ---------- produkt: pasek mobilny ---------- */
  var sbar=$('[data-sbar]'),pp=$('.pinfo__price');
  if(sbar&&pp&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){var e=es[0];sbar.classList.toggle('is-show',!e.isIntersecting&&e.boundingClientRect.top<0)},{threshold:0}).observe(pp);
  }

  /* ---------- galeria + lightbox ---------- */
  var gal=$('[data-gallery]');
  var lb=$('[data-lightbox]'),lbImg=lb&&$('[data-lb-img]',lb),lbIdx=0,fulls=[];
  function closeLb(){if(lb){lb.classList.remove('is-open');body.classList.remove('no-scroll')}}
  if(gal){
    var track=$('[data-gallery-track]',gal),slides=$$('.gallery__slide',track),thumbs=$$('[data-thumb]',gal),curEl=$('[data-gallery-cur]',gal);
    fulls=slides.map(function(s){return s.dataset.full||''});
    var idx=0;
    function go(i,smooth){i=Math.max(0,Math.min(slides.length-1,i));track.scrollTo({left:i*track.clientWidth,behavior:smooth===false?'auto':'smooth'})}
    function sync(){
      var i=Math.round(track.scrollLeft/(track.clientWidth||1));if(i===idx&&curEl&&curEl.textContent==i+1)return;idx=i;
      if(curEl)curEl.textContent=i+1;thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i)});
    }
    track.addEventListener('scroll',function(){window.requestAnimationFrame(sync)},{passive:true});
    thumbs.forEach(function(t){t.addEventListener('click',function(){go(parseInt(t.dataset.thumb,10))})});
    var pv=$('[data-gallery-prev]',gal),nx=$('[data-gallery-next]',gal);
    pv&&pv.addEventListener('click',function(e){e.stopPropagation();go(idx-1)});nx&&nx.addEventListener('click',function(e){e.stopPropagation();go(idx+1)});
    function openLb(i){
      if(!lb)return;lbIdx=i;var src=fulls[i];if(!src)return;
      lbImg.src=src;$('[data-lb-cur]',lb).textContent=i+1;$('[data-lb-total]',lb).textContent=fulls.filter(Boolean).length||slides.length;
      lb.classList.add('is-open');body.classList.add('no-scroll');
    }
    function step(d){var n=lbIdx,c=0;do{n=(n+d+fulls.length)%fulls.length;c++}while(!fulls[n]&&c<fulls.length);openLb(n);go(n,false)}
    $('[data-gallery-main]',gal).addEventListener('click',function(e){if(e.target.closest('.gallery__arrow'))return;openLb(idx)});
    var zb=$('[data-lightbox-open]',gal);zb&&zb.addEventListener('click',function(e){e.stopPropagation();openLb(idx)});
    if(lb){
      $('[data-lb-close]',lb).addEventListener('click',closeLb);lb.addEventListener('click',function(e){if(e.target===lb)closeLb()});
      $('[data-lb-prev]',lb).addEventListener('click',function(){step(-1)});$('[data-lb-next]',lb).addEventListener('click',function(){step(1)});
      document.addEventListener('keydown',function(e){if(!lb.classList.contains('is-open'))return;if(e.key==='ArrowLeft')step(-1);if(e.key==='ArrowRight')step(1)});
      var sx=0;lb.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});lb.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>50)step(dx<0?1:-1)});
    }
  }
})();
